import { InternalUserPermission } from '../../../enum/InternalUserPermission'

export enum SidebarMenu {
    Tenants = 'Tenants',
    EtpSync = 'ETP Sync',
    InvoiceDashboard = 'Invoice Dashboard',
    MarkPackagesPaid = 'Mark Packages Paid',
    APIInsights = 'API Insights',
    // TenantAnalytics = 'Onboard Analytics',
    DataPreview = 'Data Preview',
    IntegrationInsights = 'Integration Insights',
    ServiceStatus = 'Service Status',
    ErrorStatus = 'Error Dashboard',
}

export const sidebarList = Object.values(SidebarMenu)

/** Menus listed here are shown only when the user holds the mapped permission. */
export const MENU_PERMISSIONS: Partial<Record<SidebarMenu, InternalUserPermission>> = {
    [SidebarMenu.InvoiceDashboard]: InternalUserPermission.VIEW_INVOICES,
    [SidebarMenu.MarkPackagesPaid]: InternalUserPermission.MARK_PACKAGES_PAID,
}
